var exports = {
  "i": "xaee3c4fa--956472--wrapper",
};

module.exports = exports;
